import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { registerWebMCP } from "./lib/webmcp";

const rootEl = document.getElementById("root")!;

// react-snap pre-renders pages at build time. When the markup is already
// present we hydrate; otherwise we mount fresh (dev + first paint fallback).
if (rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, <App />);
} else {
  createRoot(rootEl).render(<App />);
}

// Expose site capabilities to in-browser AI agents (WebMCP).
// Runs on the client only; no-op when navigator.modelContext is unavailable.
if (typeof window !== "undefined") {
  registerWebMCP();
}
